<template>
  <g class="hc-axis" fill="none" font-size="10" :text-anchor="axis.anchor" :transform="transform">
    <g 
      v-for="(tick, index) in axis.ticks"
      :key="index"
      class="hc-axis-tick"
      :transform="transformTick(tick.transform)">
      <text
        :transform="'scale(' + scale + ')'"
        class="hc-axis-tick-text"
        stroke-width="0"
        :x="tick.text.x"
        :y="tick.text.y"
        :dy="tick.text.dy + 14 * scale"
      >
        {{tick.text.text}}
      </text>
    </g>
  </g>
</template>

<script>
import { axis } from 'd3-axis-norender'
// import transform from '../addons/transform'
export default {
  name: 'TextAxis',
  props: {
    scaleFunction: {
      type: Function,
      default () {
        return []
      }
    },
    color: {
      type: String,
      default: '#757575'
    },
    height: {
      type: Number,
      default: 275
    },
    offset: {
      type: Object,
      default () { return { top: 24, left: 48, bottom: 48, right: 48 }}
    },
    scale: {
      type: Number,
      default: 1
    },
    data: {
      type: Array,
      default () { return []}
    }
  },
  methods: {
    transformTick (tick) {
      return `translate(${tick.x}, ${tick.y})`
    }
  },
  computed: {
    axis () {
      return axis(3, this.scaleFunction).ticks(this.data.length).tickFormat(d => d)()
    },
    transform () {
      return `translate(${this.offset.left}, ${this.height + this.offset.bottom})`
    }
  }
}
</script>

<style>

</style>
